export const RBE2423_CUSTOM_SETTINGS = ['inputs', 'outputs', 'bus_selectors'];
